<template>
  <v-row>
    <!-- user profile -->
    <v-col cols="12">
      <v-card class="pt-10">
        <v-card-title class="justify-center flex-column">
          <v-avatar
            :color="colaboradorData.avatar ? '' : 'primary'"
            :class="colaboradorData.avatar ? '' : 'v-avatar-light-bg primary--text'"
            size="120"
            rounded
            class="mb-4"
          >
            <v-img
              v-if="colaboradorData.avatar"
              :src="require(`@/assets/images/avatars/${colaboradorData.avatar}`)"
            >
            </v-img>

            <span
              v-else
              class="font-weight-semibold text-5xl"
            >{{ avatarText(colaboradorData.nome) }} {{ avatarText(colaboradorData.sobrenome) }}</span>
          </v-avatar>

          <v-chip
            label
            small
            :class="`v-chip-light-bg text-sm font-weight-semibold ${colaboradorData.cargoNome}--text text-capitalize`"
          >
            {{ colaboradorData.cargoNome }}
          </v-chip>
        </v-card-title>

        <v-card-text>
          <h2 class="text-xl font-weight-semibold mb-2">
            Informações
          </h2>

          <v-divider></v-divider>

          <v-list-item
            dense
            class="px-0 mb-n2"
          >
            <span class="font-weight-medium text-no-wrap me-2">CPF:</span>
            <span class="text--secondary">{{ cpfMascara }}</span>
          </v-list-item>

          <v-list-item
            dense
            class="px-0 mb-n2"
          >
            <span class="font-weight-medium me-2">Login:</span>
            <span class="text--secondary">{{ colaboradorData.login }}</span>
          </v-list-item>

          <v-list-item
            dense
            class="px-0 mb-n2"
          >
            <span class="font-weight-medium me-2">Cargo:</span>
            <span class="text--secondary text-capitalize">{{ colaboradorData.cargoNome }}</span>
          </v-list-item>

          <v-list-item
            dense
            class="px-0 mb-n2"
          >
            <span class="font-weight-medium me-2">Departamento:</span>
            <span class="text--secondary">{{ colaboradorData.departamentoNome }}</span>
          </v-list-item>

          <v-list-item
            dense
            class="px-0 mb-n2"
          >
            <span class="font-weight-medium me-2">Perfil:</span>
            <span class="text--secondary">{{ colaboradorData.perfilNome }}</span>
          </v-list-item>

          <v-list-item
            dense
            class="px-0 mb-n2"
          >
            <span class="font-weight-medium me-2">Atuação:</span>
            <span class="text--secondary">{{ colaboradorData.atuacaoNome }}</span>
          </v-list-item>

          <v-list-item
            dense
            class="px-0 mb-n2"
          >
            <span class="font-weight-medium me-2">Status:</span>
            <v-chip
              v-if="colaboradorData.ativo"
              small
              class="ml-1"
              color="success"
              outlined
            >
              Ativo
            </v-chip>

            <v-chip
              v-else
              small
              class="ml-2"
              color="error"
              outlined
            >
              Inativo
            </v-chip>
          </v-list-item>
        </v-card-text>

        <v-card-actions class="justify-center">
          <v-btn
            v-if="!colaboradorData.ativo || !acessoPut"
            color="primary"
            class="me-3"
            disabled
          >
            Editar
          </v-btn>

          <v-btn
            v-else
            color="primary"
            class="me-3"
            @click="isBioDialogOpen = !isBioDialogOpen"
          >
            Editar
          </v-btn>

          <v-btn
            outlined
            :to="{ name: 'colaboradores' }"
          >
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>

      <colaborador-bio-edit
        :key="colaboradorData.id"
        :colaborador-data="colaboradorData"
        :is-bio-dialog-open.sync="isBioDialogOpen"
      />
    </v-col>
  </v-row>
</template>

<script>
import { ref, computed } from '@vue/composition-api'
import { avatarText, kFormatter } from '@core/utils/filter'
import { mdiAccountOutline, mdiBriefcaseVariantOutline, mdiCheck, mdiCheckboxBlankCircle } from '@mdi/js'
import { maskCpf } from '@/utils/validation'
import ColaboradorBioEdit from './ColaboradorBioEdit.vue'

export default {
  components: {
    ColaboradorBioEdit,
  },

  props: {
    colaboradorData: {
      type: Object,
      default: () => {},
    },
    acessoPut: {
      type: Boolean,
      default: () => true,
    },
  },

  setup(props) {
    const isBioDialogOpen = ref(false)

    const cpfMascara = computed(() => maskCpf(props.colaboradorData.cpf))

    return {
      avatarText,
      kFormatter,
      isBioDialogOpen,
      cpfMascara,
      icons: {
        mdiAccountOutline,
        mdiCheck,
        mdiBriefcaseVariantOutline,
        mdiCheckboxBlankCircle,
      },
    }
  },
}
</script>
